module.exports = __webpack_public_path__ + "img/chanpin2.bd7e0234.png";